import ActiveUserFlagStore from 'contest/stores/active-user-flag-store';
import { setUserFlagAction } from './set-user-flag';

export const dismissOnboardingPrompt = (context, { key }) => {
    const flag = `onboarding-dismiss_${key}`;
    if (!context.getStore(ActiveUserFlagStore).has(flag)) {
        context.executeAction(setUserFlagAction, { flag });
    }
};



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/dismiss-onboarding-prompt.js